module.exports = __webpack_public_path__ + "static/media/customer1.8506cac4.jpeg";